import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Styles from "./OngoingBanking.module.css";
import UpdateLedger from "../../../Modals/Banking/UpdateLedger/UpdateLedger";
import { ReactComponent as SquareIcon } from "../../../../assets/images/squareIcon.svg";
import ViewInjectionModal from "../../../Modals/Banking/ViewInjectionModal/ViewInjectionModal";
import ViewDrawalModal from "../../../Modals/Banking/ViewDrawalModal/ViewDrawalModal";
import ViewDoc from "../../../Modals/Banking/ViewDoc/ViewDoc";
import Loader from "../../../../commons/Loader/Loader";
import { useDispatch } from "react-redux";
import InfoExchanged from "../../../Modals/Banking/InfoExchanged/InfoExchanged";
import {
  fetchConnectionHistory,
  terminateBankingListing,
  fetchMatchmakingResults,
} from "../../../../Redux/Slices/bankingSlice";
import ConnectionHistory from "../../../Modals/Banking/ConnectionHistory/ConnectionHistory";
import OngoingBankingTable from "./OngoingBankingTable";
import { ReactComponent as HistoryIcon } from "../../../../assets/images/history.svg";
import { ReactComponent as VectorIcon } from "../../../../assets/images/VectorIcon.svg";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "../../../../commons/Accordion";

// import { ReactComponent as ExpandMoreIcon } from "../../../../assets/images/expandMoreIcon.svg";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TermsConditionModal from "../../../Modals/Banking/TermsConditionModal/TermsConditionModal";
import ChatApplication from "../../../ChatApplication/ChatApplication";
import { Skeleton } from "@mui/material";
import { connectionClose } from "../../../../Services/ApiCalling/banking";
import ClosePopup from "../../../../commons/PopupModal/BankingPopup/ClosePopup/ClosePopup";

const OngoingBanking = ({
  data = [],
  currentPage = 0,
  itemsPerPage = 10,
  totalCount = 0,
  onPageChange,
  activeListingId,
  isLoading = false,
}) => {
  const [expanded, setExpanded] = useState(null);
  const [filteredData, setFilteredData] = useState(data);
  const [finalModal, setFinalModal] = useState(false);
  const [selectedConnection, setSelectedConnection] = useState(null);
  const [selectedCounterparty, setSelectedCounterparty] = useState(null);
  const [modalViewOnly, setModalViewOnly] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const [chatConnectionId, setChatConnectionId] = useState(null);
  const [chatName, setChatName] = useState("");
  const [isClosePopupOpen, setIsClosePopupOpen] = useState(false);
  const [selectedConnectionId, setSelectedConnectionId] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [modalState, setModalState] = useState({
    ledgerOpen: false,
    injectionModalOpen: false,
    drawalModalOpen: false,
    docOpen: false,
    infoExchanged: false,
    connectionHistory: false,
  });
  const [selectedData, setSelectedData] = useState({
    connectionId: null,
    injectionData: [],
    drawalData: [],
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setFilteredData(data);
    setLoading(false);
  }, [data]);

  const handlePageChange = (newPage) => {
    setLoading(true);
    setExpanded(null);
    onPageChange(newPage);
  };
  const closeLedger = () => setModalState((s) => ({ ...s, ledgerOpen: false }));

  const closeViewDoc = () => setModalState((s) => ({ ...s, docOpen: false }));

  const closeInfo = () =>
    setModalState((s) => ({ ...s, infoExchanged: false }));

  const closeConnection = () => {
    setModalState((s) => ({ ...s, connectionHistory: false }));
  };

  const toggleAccordion = (index) =>
    setExpanded((prev) => (prev === index ? null : index));

  const handleNavigateToListing = (bankingListing) => {
    if (bankingListing?.id) {
      // Call the correct API endpoint: /banking/matches?id=${id}&currentPage=0&size=10
      dispatch(
        fetchMatchmakingResults({
          id: bankingListing.id,
          statusFilter: null,
        })
      );
      // Navigate to the specified URL with state to indicate origin
      navigate(`/banking_active?id=${bankingListing.id}`, {
        state: {
          fromBankingLedger: true,
          activeTab: "Ongoing Banking",
          listingId: bankingListing.id,
          listingName: bankingListing.name,
        },
      });
    }
  };

  const closeInjectionModal = () =>
    setModalState((s) => ({ ...s, injectionModalOpen: false }));
  const closeDrawalModal = () =>
    setModalState((s) => ({ ...s, drawalModalOpen: false }));

  const totalPages = Math.max(1, Math.ceil(totalCount / itemsPerPage));

  const renderDateRangeWithIcon = (dateStartAt, dateEndAt, onClick) => (
    <>
      {dateStartAt || "—"} to {dateEndAt || "—"}
      <span onClick={onClick} style={{ cursor: "pointer" }}>
        <SquareIcon />
      </span>
    </>
  );

  const handleHistoryClick = (listingId) => {
    if (listingId) {
      dispatch(fetchConnectionHistory(listingId));
    }
  };

  const openInjectionModal = (e, injectionData) => {
    if (e && e.stopPropagation) e.stopPropagation();
    setSelectedData((s) => ({ ...s, injectionData }));
    setModalState((s) => ({ ...s, injectionModalOpen: true }));
  };

  const openDrawalModal = (e, drawalData) => {
    if (e && e.stopPropagation) e.stopPropagation();
    setSelectedData((s) => ({ ...s, drawalData }));
    setModalState((s) => ({ ...s, drawalModalOpen: true }));
  };

  const openViewDoc = (connectionId) => {
    setModalState((s) => ({ ...s, docOpen: true }));
    setSelectedData((s) => ({ ...s, connectionId }));
  };

  const openLedger = (listingId, connectionObj) => {
    setModalState((s) => ({ ...s, ledgerOpen: true }));
    setSelectedData((s) => ({
      ...s,
      listingId,
      connectionObj,
      connectionId: connectionObj?.id,
    }));
  };

  function parseDMY(str) {
    if (!str) return null;
    const datePart = String(str).trim().split(" ")[0];
    const [dd, mmm, yyyy] = datePart.split("-");
    const months = {
      Jan: 0,
      Feb: 1,
      Mar: 2,
      Apr: 3,
      May: 4,
      Jun: 5,
      Jul: 6,
      Aug: 7,
      Sep: 8,
      Oct: 9,
      Nov: 10,
      Dec: 11,
      JAN: 0,
      FEB: 1,
      MAR: 2,
      APR: 3,
      MAY: 4,
      JUN: 5,
      JUL: 6,
      AUG: 7,
      SEP: 8,
      OCT: 9,
      NOV: 10,
      DEC: 11,
    };
    const month = months[mmm];
    const day = parseInt(dd, 10);
    const year = parseInt(yyyy, 10);
    if (Number.isNaN(day) || Number.isNaN(year) || month == null) return null;
    return new Date(year, month, day);
  }

  function startOfDay(d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  function addDays(d, days) {
    const x = new Date(d);
    x.setDate(x.getDate() + days);
    return x;
  }

  const getMaxEndDate = (counterParties) => {
    const injectDates = [];
    const drawalDates = [];

    counterParties.forEach((cp) => {
      if (cp?.finalizedConnectionValues?.slotInjects) {
        cp.finalizedConnectionValues.slotInjects.forEach((inject) => {
          if (inject?.dateEndAt) {
            injectDates.push(parseDMY(inject.dateEndAt));
          }
        });
      }
      if (cp?.finalizedConnectionValues?.slotDrawls) {
        cp.finalizedConnectionValues.slotDrawls.forEach((drawal) => {
          if (drawal?.dateEndAt) {
            drawalDates.push(parseDMY(drawal.dateEndAt));
          }
        });
      }

      cp?.bankingSlotInjects?.forEach((inject) => {
        if (inject?.dateEndAt) {
          injectDates.push(parseDMY(inject.dateEndAt));
        }
      });
      cp?.bankingSlotDrawls?.forEach((drawal) => {
        if (drawal?.dateEndAt) {
          drawalDates.push(parseDMY(drawal.dateEndAt));
        }
      });
    });

    const allDates = [...injectDates, ...drawalDates].filter(Boolean);
    if (allDates.length === 0) return null;
    return allDates.reduce((a, b) => (a > b ? a : b));
  };

  function handleClose(connectionId) {
    if (!connectionId) return;

    connectionClose(connectionId)
      .then(() => {
        window.location.reload();
      })
      .catch((error) => {
        console.error("Failed to close connection", error);
      });
  }

  const finalized = data.finalizedConnectionValues || {};

  const slotDrawlsEndDate = finalized.slotDrawls?.[0]?.dateEndAt;
  const slotInjectsEndDate = finalized.slotInjects?.[0]?.dateEndAt;

  const d1 = parseDMY(slotDrawlsEndDate);
  const d2 = parseDMY(slotInjectsEndDate);
  const dates = [d1, d2].filter(Boolean);
  const farthestEndDatePlusOne =
    dates.length === 0
      ? null
      : addDays(startOfDay(dates.reduce((a, b) => (a > b ? a : b))), 1);

  const canShowClose = farthestEndDatePlusOne
    ? startOfDay(new Date()) >= farthestEndDatePlusOne
    : false;

  const handleChatOpen = (chatConnectionId, name) => {
    setChatConnectionId(chatConnectionId);
    setChatName(name);
    setChatOpen(true);
  };

  const handleOpenClosePopup = (connectionId) => {
    setSelectedConnectionId(connectionId);
    setIsClosePopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsClosePopupOpen(false);
    setSelectedConnectionId(null);
  };

  const handleConfirmClose = async () => {
    setLoading(true);
    try {
      await connectionClose(selectedConnectionId);
      setLoading(false);
      setIsClosePopupOpen(false);
      window.location.reload();
    } catch (error) {
      setLoading(false);
      console.error("Failed to close connection", error);
    }
  };

  const skeletonRowCount = 8;

  return (
    <>
      {finalModal && (
        <TermsConditionModal
          open={finalModal}
          handleClose={() => setFinalModal(false)}
          connectionId={selectedConnection?.id}
          activeData={selectedConnection}
          activeCounterparty={selectedCounterparty}
          activeListingId={activeListingId}
          termsData={[selectedConnection]}
          viewOnly={modalViewOnly}
        />
      )}

      {modalState.ledgerOpen && (
        <UpdateLedger
          open={modalState.ledgerOpen}
          handleClose={closeLedger}
          connectionId={selectedData.connectionId}
          ongoingData={filteredData}
          connectionData={selectedData.connectionObj}
          listingId={selectedData.listingId}
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
          totalCount={totalCount}
          onPageChange={onPageChange}
          activeListingId={activeListingId}
        />
      )}

      {modalState.infoExchanged && (
        <InfoExchanged
          open={modalState.infoExchanged}
          handleClose={closeInfo}
          connectionId={selectedData.connectionId}
        />
      )}

      {modalState.connectionHistory && (
        <ConnectionHistory
          open={modalState.connectionHistory}
          handleClose={closeConnection}
          connectionId={selectedData.connectionId}
        />
      )}

      {modalState.injectionModalOpen && (
        <ViewInjectionModal
          open={modalState.injectionModalOpen}
          handleClose={closeInjectionModal}
          data={selectedData.injectionData}
        />
      )}
      {modalState.drawalModalOpen && (
        <ViewDrawalModal
          open={modalState.drawalModalOpen}
          handleClose={closeDrawalModal}
          data={selectedData.drawalData}
        />
      )}
      {modalState.docOpen && (
        <ViewDoc
          open={modalState.docOpen}
          handleClose={closeViewDoc}
          connectionId={selectedData.connectionId}
        />
      )}

      <ClosePopup
        open={isClosePopupOpen}
        handleClose={handleClosePopup}
        onConfirm={handleConfirmClose}
        loading={loading}
      />

      <div>
        <div className={Styles.ongoingBankingMainContainer}>
          <div className={`display_flex_row ${Styles.tableActiveCont}`}>
            <div className={`${Styles.tableHeaderActive} display_flex_row`}>
              <div style={{ width: "2px" }}></div>
              <div style={{ width: "18%" }}>Listing ID</div>
              <div style={{ width: "20%" }}>Injection Range</div>
              <div style={{ width: "20%" }}>Drawal Range</div>
              <div style={{ width: "10%" }}>BF(%)</div>
              <div style={{ width: "10%" }}>SR(₹/kWh)</div>
              {/* <div style={{ width: "10.5%" }}>Status</div> */}
            </div>
          </div>
          <div className={`${Styles.tableContentOngoing} `}>
            {isLoading ? (
              <div className={`scroll_bar_y ${Styles.tableContentActive}`}>
                {Array.from({ length: skeletonRowCount }).map((_, i) => (
                  <div
                    key={i}
                    className={`${Styles.activeAccordion} ${
                      i % 2 === 0 ? Styles.accordionEven : Styles.accordionOdd
                    }`}
                    style={{
                      minHeight: 45,
                      marginBottom: "2px",
                    }}
                  >
                    <div
                      className={`display_flex_row ${Styles.tableActiveCont}`}
                      style={{
                        minHeight: 45,
                        alignItems: "center",
                      }}
                    >
                      <div className={Styles.tableAccordionData}>
                        <div style={{ width: "2%" }}>
                          <Skeleton variant="circular" width={24} height={24} />
                        </div>
                        <div style={{ width: "16%" }}>
                          <Skeleton variant="text" width="80%" height={16} />
                          <Skeleton variant="text" width="60%" height={12} />
                        </div>
                        <div style={{ width: "20%" }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            {/* <Skeleton variant="text" width="70%" height={16} /> */}
                            <Skeleton variant="rectangular" width={100} />
                          </div>
                        </div>
                        <div style={{ width: "22%" }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            {/* <Skeleton variant="text" width="70%" height={16} /> */}
                            <Skeleton
                              variant="rectangular"
                              width={100}
                              // height={16}
                            />
                          </div>
                        </div>
                        <div style={{ width: "10%" }}>
                          <Skeleton variant="text" width="50%" height={16} />
                        </div>
                        <div style={{ width: "11%" }}>
                          <Skeleton variant="text" width="50%" height={16} />
                        </div>
                        <div style={{ width: "8%" }}>
                          <Skeleton variant="text" width="20%" height={16} />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              // <div className={`scroll_bar_y ${Styles.tableContentAccordion}`}>
              //   <OngoingBankingTable
              //     filteredData={filteredData}
              //     expanded={expanded}
              //     setExpanded={setExpanded}
              //     setModalState={setModalState}
              //     setSelectedData={setSelectedData}
              //     handleHistoryClick={handleHistoryClick}
              //     setFilteredData={setFilteredData}
              //   />
              // </div>
              <div className={`scroll_bar_y ${Styles.tableContentActive}`}>
                {filteredData.map((item, i) => {
                  const {
                    bankingListing,
                    againstBankingListing: counterparty,
                    agreementStatus,
                    id,
                  } = item;
                  const inject = bankingListing?.bankingSlotInjects?.[0];
                  const drawal = bankingListing?.bankingSlotDrawls?.[0];
                  const injectAgainst = counterparty?.bankingSlotInjects?.[0];
                  const drawalAgainst = counterparty?.bankingSlotDrawls?.[0];
                  // Check for finalizedConnectionValues on the main item (based on your data structure)
                  let maxDate = null;
                  if (item.finalizedConnectionValues) {
                    // Use the item itself if it has finalizedConnectionValues
                    maxDate = getMaxEndDate([item]);
                  } else if (counterparty) {
                    // Fallback to counterparty for backward compatibility
                    maxDate = getMaxEndDate([counterparty]);
                  } else if (item.againstBankingListing) {
                    // Fallback to againstBankingListing for backward compatibility
                    maxDate = getMaxEndDate([item.againstBankingListing]);
                  }

                  const activeDate = maxDate
                    ? addDays(startOfDay(maxDate), 1)
                    : null;

                  const canShowCloseForItem = activeDate
                    ? startOfDay(new Date()) >= activeDate
                    : false;

                  return (
                    <Accordion
                      key={id}
                      expanded={false}
                      onChange={() => handleNavigateToListing(bankingListing)}
                      className={`${Styles.activeAccordion}`}
                    >
                      <AccordionSummary sx={{ minHeight: 45 }}>
                        {/* Summary Row */}
                        <div
                          className={`display_flex_row ${
                            Styles.tableActiveCont
                          } ${
                            expanded === i
                              ? Styles.expandedRow
                              : i % 2 === 0
                              ? Styles.accordionEven
                              : Styles.accordionOdd
                          }`}
                        >
                          <div className={Styles.tableAccordionData}>
                            <div style={{ width: "2%" }}>
                              <div
                                style={{
                                  width: 24,
                                  height: 24,
                                  color: "#C5C5CBD9",
                                }}
                              >
                                <ExpandMoreIcon
                                  className={`${Styles.expandIconLeft} ${
                                    expanded === i ? Styles.rotateIcon : ""
                                  }`}
                                  style={{
                                    width: 24,
                                    height: 24,
                                  }}
                                />
                              </div>
                            </div>
                            <div
                              style={{ width: "16%" }}
                              className={Styles.companyLeft}
                            >
                              {expanded === i ? (
                                bankingListing?.name || "—"
                              ) : (
                                <>
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      color: "#8C8A96",
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    {counterparty &&
                                    counterparty.companyName ? (
                                      <>{counterparty.companyName}</>
                                    ) : (
                                      "—"
                                    )}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "10px",
                                      color: "#8C8A96",
                                    }}
                                  >
                                    {bankingListing?.name || "—"}
                                  </div>
                                </>
                              )}
                            </div>
                            <div style={{ width: "20%" }}>
                              {renderDateRangeWithIcon(
                                inject?.dateStartAt,
                                inject?.dateEndAt,
                                (e) => {
                                  e.stopPropagation();
                                  setSelectedData((s) => ({
                                    ...s,
                                    injectionData:
                                      bankingListing?.bankingSlotInjects || [],
                                  }));
                                  setModalState((s) => ({
                                    ...s,
                                    injectionModalOpen: true,
                                  }));
                                }
                              )}
                            </div>
                            <div
                              style={{
                                width: "21%",
                              }}
                            >
                              {renderDateRangeWithIcon(
                                drawal?.dateStartAt,
                                drawal?.dateEndAt,
                                (e) => {
                                  e.stopPropagation();
                                  setSelectedData((s) => ({
                                    ...s,
                                    drawalData:
                                      bankingListing?.bankingSlotDrawls || [],
                                  }));
                                  setModalState((s) => ({
                                    ...s,
                                    drawalModalOpen: true,
                                  }));
                                }
                              )}
                            </div>
                            <div style={{ width: "4%" }}>
                              {bankingListing?.bankingFactor || "—"}
                            </div>
                            <div style={{ width: "15%" }}>
                              {bankingListing?.settlementRate || "—"}
                            </div>
                            {/* <div style={{ width: "13%" }}>-</div> */}
                          </div>
                        </div>
                      </AccordionSummary>
                      <AccordionDetails>
                        <div className={Styles.accordionDetailsSubCont}>
                          <span className={Styles.borderLabel}>
                            Counterparty Listings
                          </span>
                          {counterparty && (
                            <div className={Styles.ongoingBankingData}>
                              <div style={{ width: "2%" }}></div>
                              <div style={{ width: "16%" }}>
                                {" "}
                                <span
                                  style={{
                                    fontSize: "14px",
                                    textTransform: "capitalize",
                                    fontWeight: "500",
                                  }}
                                >
                                  {counterparty.companyName || "—"}
                                </span>{" "}
                                <span style={{ fontSize: "10px" }}>
                                  {counterparty.name || ""}
                                </span>
                              </div>
                              <div style={{ width: "20%" }}>
                                {renderDateRangeWithIcon(
                                  injectAgainst?.dateStartAt,
                                  injectAgainst?.dateEndAt,
                                  (e) =>
                                    openInjectionModal(
                                      e,
                                      counterparty?.bankingSlotInjects || []
                                    )
                                )}
                              </div>
                              <div style={{ width: "22%" }}>
                                {" "}
                                {renderDateRangeWithIcon(
                                  drawalAgainst?.dateStartAt,
                                  drawalAgainst?.dateEndAt,
                                  (e) =>
                                    openDrawalModal(
                                      e,
                                      counterparty?.bankingSlotDrawls || []
                                    )
                                )}
                              </div>
                              <div style={{ width: "4%" }}>
                                {counterparty.bankingFactor || "—"}
                              </div>
                              <div style={{ width: "15%" }}>
                                {" "}
                                {counterparty.settlementRate || "—"}
                              </div>
                              {/* <div style={{ width: "13%" }}>
                                {" "}
                                {counterparty.status || "—"}
                              </div> */}
                            </div>
                          )}
                          <div className={Styles.accordionSubDetailsSection}>
                            <div className={Styles.accordionBankingSection}>
                              <div className={Styles.innerFinalContent}>
                                <div
                                  style={{ width: "17%", paddingLeft: "2.5%" }}
                                >
                                  <div className={Styles.finalHead}>
                                    Final Terms and Conditions
                                  </div>
                                </div>
                                <div
                                  style={{
                                    width: "22%",
                                  }}
                                >
                                  {renderDateRangeWithIcon(
                                    inject?.dateStartAt,
                                    inject?.dateEndAt,
                                    (e) =>
                                      openInjectionModal(
                                        e,
                                        bankingListing?.bankingSlotInjects || []
                                      )
                                  )}
                                </div>
                                <div
                                  style={{
                                    width: "21%",
                                  }}
                                >
                                  {renderDateRangeWithIcon(
                                    drawal?.dateStartAt,
                                    drawal?.dateEndAt,
                                    (e) =>
                                      openDrawalModal(
                                        e,
                                        bankingListing?.bankingSlotDrawls || []
                                      )
                                  )}
                                </div>
                                <div style={{ width: "8%" }}>
                                  {bankingListing?.bankingFactor || "—"}
                                </div>
                                <div
                                  style={{
                                    width: "12%",
                                  }}
                                >
                                  {bankingListing?.settlementRate || "—"}
                                </div>
                                {/* <div style={{ width: "9%" }}>
                                  {bankingListing?.status || "—"}
                                </div> */}
                              </div>
                              <div className={Styles.finalContainer}>
                                <div
                                  className={Styles.connHead}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    const listingId = item.bankingListing?.id;
                                    if (listingId) {
                                      handleHistoryClick(listingId);

                                      setSelectedData((s) => ({
                                        ...s,
                                        connectionId: listingId,
                                      }));

                                      setModalState((s) => ({
                                        ...s,
                                        connectionHistory: true,
                                      }));
                                    }
                                  }}
                                  style={{
                                    cursor: "pointer",
                                  }}
                                >
                                  <span
                                    style={{
                                      cursor: "pointer",
                                    }}
                                  >
                                    <HistoryIcon
                                      style={{ width: 14, height: 14 }}
                                    />
                                  </span>
                                  Connection History
                                  <span>
                                    <VectorIcon
                                      style={{
                                        width: 8,
                                        height: 8,
                                        cursor: "pointer",
                                      }}
                                    />
                                  </span>
                                </div>
                                <div className={Styles.connectionCont}>
                                  <div className={Styles.buttonsSection}>
                                    <div
                                      className={Styles.chatBtn}
                                      style={true ? { cursor: "pointer" } : {}}
                                      onClick={
                                        true
                                          ? () =>
                                              handleChatOpen(
                                                item.id,
                                                bankingListing?.name
                                              )
                                          : undefined
                                      }
                                    >
                                      Chat
                                    </div>
                                    <div
                                      className="activeButton_type_2"
                                      onClick={() => {
                                        setSelectedConnection(
                                          item?.bankingListing
                                        );
                                        setSelectedCounterparty(
                                          item?.againstBankingListing
                                        );
                                        setModalViewOnly(true);
                                        setFinalModal(true);
                                      }}
                                    >
                                      View T&C
                                    </div>

                                    <div
                                      className="activeButton_type_2"
                                      onClick={() => openViewDoc(id)}
                                    >
                                      View Documents
                                    </div>
                                    <div
                                      className="activeButton"
                                      onClick={() =>
                                        openLedger(item.bankingListingId, item)
                                      }
                                    >
                                      Ledger
                                    </div>
                                    {canShowCloseForItem ? (
                                      <div
                                        className="activeButton"
                                        // onClick={() => handleClose(item.id)}
                                        onClick={() =>
                                          handleOpenClosePopup(item.id)
                                        }
                                      >
                                        Close
                                      </div>
                                    ) : (
                                      <div
                                        className={Styles.chatBtn}
                                        style={{ cursor: "not-allowed" }}
                                      >
                                        Close
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  );
                })}
              </div>
            )}
          </div>
          <div className={Styles.paginationWrapper}>
            <button
              disabled={currentPage <= 0 || loading}
              onClick={() => handlePageChange(currentPage - 1)}
            >
              Prev
            </button>
            <span>
              Page {currentPage + 1} of {totalPages}
            </span>
            <button
              disabled={currentPage + 1 >= totalPages || loading}
              onClick={() => handlePageChange(currentPage + 1)}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default OngoingBanking;
